import { render, staticRenderFns } from "./shareholders.vue?vue&type=template&id=50b90ebc&scoped=true"
import script from "./shareholders.vue?vue&type=script&lang=js"
export * from "./shareholders.vue?vue&type=script&lang=js"
import style0 from "./shareholders.vue?vue&type=style&index=0&id=50b90ebc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b90ebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b90ebc')) {
      api.createRecord('50b90ebc', component.options)
    } else {
      api.reload('50b90ebc', component.options)
    }
    module.hot.accept("./shareholders.vue?vue&type=template&id=50b90ebc&scoped=true", function () {
      api.rerender('50b90ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shareholders.vue"
export default component.exports